import React from 'react';
import styled from 'styled-components';

import { PublicSessionLoginContinue } from 'src/assets/public-session-login-continue';
import { PublicSessionLoginSuccess } from 'src/assets/public-session-login-success';
import {
  ContentContainer,
  Title,
  Subtitle,
  KIOSK_PRO_MEDIA,
} from 'src/components/kiosk-pro/kiosk-pro-shared/kiosk-pro-shared.styles';

export function KioskLoginContinue({
  isUserLoggedInSuccessfully,
  userFirstName,
}: {
  isUserLoggedInSuccessfully: boolean;
  userFirstName: string;
}): JSX.Element {
  return (
    <ContentContainer>
      {isUserLoggedInSuccessfully ? (
        <>
          <PublicSessionLoginSuccess />
          <ContinueTitle>
            <span aria-hidden='true'>👋</span>
            &nbsp; Hi, {userFirstName}!
          </ContinueTitle>
        </>
      ) : (
        <>
          <PublicSessionLoginContinue />
          <ContinueTitle>Continue on your phone</ContinueTitle>
          <ContinueSubTitle>This screen will automatically refresh</ContinueSubTitle>
        </>
      )}
    </ContentContainer>
  );
}

const ContinueTitle = styled(Title)`
  font-size: 72px;
  font-weight: 700;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: 56px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 48px;
  }
`;

const ContinueSubTitle = styled(Subtitle)`
  font-size: 36px;
  font-weight: 500;

  @media ${KIOSK_PRO_MEDIA.portraitMaxWidth}, ${KIOSK_PRO_MEDIA.landscapeMaxWidth} {
    font-size: 28px;
  }

  @media ${KIOSK_PRO_MEDIA.smallViewportPortrait}, ${KIOSK_PRO_MEDIA.smallViewportLandscapeOnly} {
    font-size: 24px;
  }
`;
